export const fileSet = [{
		name: 'KEY_READFILEPATH',
		Display: '读取地址',
		type: 1,
		must: true,
		disabled: false,
		dic: 1
	},
	{
		name: 'KEY_PACKFILEPATH',
		Display: '备份地址',
		type: 1,
		must: true,
		disabled: false,
		dic: 1
	},
	{
		name: 'KEY_PACKFAILPATH',
		Display: '失败备份地址',
		type: 1,
		must: true,
		disabled: false,
		dic: 1
	},
	{
		name: 'KEY_TIMEINTERVAL',
		Display: '同步间隔时间(秒)',
		dataType: 'number',
		type: 1,
		min: '0',
		must: true,
		disabled: false,
		dic: 2
	}
]
export const ASNfiletSet = [{
		name: 'KEY_ASNPACK',
		Display: '提交地址',
		type: 1,
		must: true,
		disabled: false,
		dic: 1
	},
	{
		name: 'KEY_ASNCOMMIT',
		Display: '备份地址',
		type: 1,
		must: true,
		disabled: false,
		dic: 1
	},
	{
		name: 'KEY_BMWSREADED',
		Display: 'BMW读取地址',
		type: 1,
		must: true,
		disabled: false,
		dic: 1
	}
]
export const pass = [{
		name: 'old',
		Display: '旧密码',
		dataType: 'password',
		must: true,
		type: 1
	},
	{
		name: 'repass',
		Display: '新密码',
		dataType: 'password',
		must: true,
		type: 1
	},
	{
		name: 'recheckpass',
		Display: '确认密码',
		dataType: 'password',
		must: true,
		type: 1
	}
]
